<template>
  <div class="h-screen flex flex-col">
    <common-nav :show-cart="true"></common-nav>
    <div class="flex-grow">
      <router-view></router-view>
    </div>
    <footer-outfitter></footer-outfitter>
  </div>
</template>

<script>
import CommonNav from "@/components/ui/nav/CommonNav";
import FooterOutfitter from "@/components/ui/footer/FooterOutfitter";

export default {
  name: "Outfitter",
  components: {
    FooterOutfitter,
    CommonNav,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    outfitter() {
      const outfitter = this.$store.getters["search/getOutfitter"];
      if (outfitter.meta_title) {
        document.title = outfitter.meta_title;
      }
      if (outfitter.meta_description) {
        const tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        tag.content = outfitter.meta_description;
        document.head.appendChild(tag);
      }
      return outfitter;
    },
  },
  mounted() {
    this.$store
      .dispatch("search/get_outfitter", this.$route.params.slug)
      .then((resp) => {
        if (!resp.success) return;

        if (this.outfitter.body_color) {
          document.getElementById(
            "customBodyColor"
          ).style.backgroundColor = this.outfitter.body_color;
        }
        if (this.outfitter.header_color) {
          document.getElementById(
            "customNavColor"
          ).style.backgroundColor = this.outfitter.header_color;
        }
        if (this.outfitter.text_color) {
          document.getElementById(
            "app"
          ).style.color = this.outfitter.text_color;
        }
      });
  },
};
</script>

<style scoped></style>
